export default __webpack_public_path__ + "static/media/competitions.0d5d9357.svg";